export default __webpack_public_path__ + "images/96b870a67f542153bc65e9c3aa1e0bac-halloweenhaunt_small.webp";